<script setup lang="ts">
/**
 * Drifting particles — glowing accent dots floating over soft color glows.
 * Deterministic pseudo-random placement so SSR and client render the same
 * markup. Motion is pure CSS (site-themes.css) and freezes under
 * prefers-reduced-motion.
 */
const COUNT = 26

// Simple LCG keeps positions stable across server/client renders.
const rand = (() => {
  let seed = 42
  return () => {
    seed = (seed * 48271) % 2147483647
    return seed / 2147483647
  }
})()

const particles = Array.from({ length: COUNT }, () => ({
  left: `${Math.round(rand() * 100)}%`,
  top: `${Math.round(rand() * 100)}%`,
  size: `${(2 + rand() * 4).toFixed(1)}px`,
  dur: `${(7 + rand() * 8).toFixed(1)}s`,
  twinkle: `${(3 + rand() * 5).toFixed(1)}s`,
  driftX: `${Math.round(rand() * 28 - 14)}px`,
  driftY: `${Math.round(rand() * -26 - 6)}px`
}))
</script>

<template>
  <div
    class="site-hero-anim"
    aria-hidden="true"
  >
    <div
      class="absolute -top-1/4 -left-1/4 h-2/3 w-2/3 rounded-full opacity-20"
      style="background: var(--site-accent); filter: blur(120px)"
    />
    <div
      class="absolute -bottom-1/4 -right-1/4 h-2/3 w-2/3 rounded-full opacity-15"
      style="background: var(--site-accent); filter: blur(140px)"
    />
    <span
      v-for="(p, i) in particles"
      :key="i"
      class="site-anim-particle"
      :style="{
        'left': p.left,
        'top': p.top,
        'width': p.size,
        'height': p.size,
        '--dur': p.dur,
        '--twinkle': p.twinkle,
        '--drift-x': p.driftX,
        '--drift-y': p.driftY
      }"
    />
  </div>
</template>
